/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionPrecomputeStatusEntry {
    getFixupPrototypeFunction() { return DimensionPrecomputeStatusEntry.fixupPrototype; }

    static newInstance(model: Partial<DimensionPrecomputeStatusEntry>): DimensionPrecomputeStatusEntry {
        let obj = Object.assign(new DimensionPrecomputeStatusEntry(), model);
        DimensionPrecomputeStatusEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionPrecomputeStatusEntry>): DimensionPrecomputeStatusEntry {
        if (!model) return null;
        return DimensionPrecomputeStatusEntry.newInstance(<DimensionPrecomputeStatusEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionPrecomputeStatusEntry) {
        if (!obj) return;

        models.DimensionPrecomputeStatusEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionPrecomputeStatusEntry): boolean {
        Object.setPrototypeOf(obj, DimensionPrecomputeStatusEntry.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.records_reprocessed === undefined) {
            this.records_reprocessed = 0;
        }
        if (this.version_state) {
            models.DimensionPrecomputeVersionState.fixupPrototype(this.version_state);
        }
    }

    /**
     * Dimension definition ID
     */
    dimension_id: string;

    /**
     * Per-dimension status: completed, failed, pending, disabled, no_data
     */
    status: models.DimensionPrecomputeStatus;

    /**
     * head_version sys_id at time of last successful precompute
     */
    last_precomputed_version_id: string;

    /**
     * Records reprocessed for this dimension in last run
     */
    records_reprocessed: number;

    /**
     * Status message or error detail
     */
    message: string;

    /**
     * Current version state of the dimension
     */
    version_state: models.DimensionPrecomputeVersionState;

}
